<nz-tabset style="height:auto" [nzTabPosition]="'left'">

  <nz-tab [nzTitle]="titleTmplInsuredDecision" (nzClick)="filterAllRules('All')">
    <ng-template #titleTmplInsuredDecision>
      <strong class="d-b">All Rules</strong>
    </ng-template>
    <!-- <div class="rules-section">
      <div class="flex flex-horiz-space-bw m-t-b-10">
        <nz-radio-group [(ngModel)]="rulesRadio" [nzButtonStyle]="'solid'" (ngModelChange)="filterAllRules()">
          <label nz-radio-button nzValue="All">All</label>
          <label nz-radio-button nzValue="Passed">Accepted</label>
          <label nz-radio-button nzValue="Failed">Referred</label>
        </nz-radio-group>
        <div class="f-s-1-3r p-r-5">
          <span class="clickable" (click)="filterAllRules('All')">{{rulesData.length}} Rules </span> &bull;
          <span class="col-green clickable" (click)="filterAllRules('Passed')">{{rulesPassedCount}}
            Accepted</span>&bull;
          <span class="col-red clickable" (click)="filterAllRules('Failed')">{{rulesFailedCount}} Referred
          </span>
        </div>
      </div>

      <h3 class="heading d-b m-t-b-20"><i nz-icon nzType="profile"></i> Showing {{rulesRadio.toString().toLowerCase()}}
        rules
        ({{rulesDataFiltered.length}})</h3>

      <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="rulesLoading">
        <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false">
          <thead class="table-header">
            <tr>
              <th class="">Rule Name</th>
              <th class="" nzShowFilter [nzFilters]="listOfCategories" (nzFilterChange)="filterRulesOnCategory($event)">
                Rule Category</th>
              <th class="">Decision</th>
              <th class="" style="width: 170px">Decision Value</th>
              <th class="">Recommendation</th>
            </tr>
          </thead>
          <tbody class="">
            <tr class="table-row" *ngFor="let rule of rulesDataFiltered">
              <td class="">{{((rule.name || rule.ruleName) | technicalTranslate) || "-"}}</td>
              <td class="">{{(rule.category | technicalTranslate) || "-"}}</td>
              <td
                [class.col-green]="rule.decision=='Accepted' || rule.decision=='ACCEPTED' || rule.decision=='STANDARD'"
                [class.col-red]="rule.decision=='Refer' || rule.decision=='REFER'" class="">
                {{(rule.decision | technicalTranslate) || "-"}}</td>
              <td class="">{{rule.decisionValue || "-"}}</td>
              <td class="">{{(rule.recco || rule.recommendation) || "-"}}</td>
            </tr>
          </tbody>
        </nz-table>
      </nz-skeleton>
    </div> -->
    <div *ngIf="false" class="rules-section" style="overflow-x: scroll">
      <div class="flex flex-horiz-space-bw m-t-b-10">
        <nz-radio-group [(ngModel)]="rulesRadio" [nzButtonStyle]="'solid'"
          (ngModelChange)="filterRules(rulesRadio)">
          <ng-container *ngFor="let item of decisionCategoryLookup">
            <label nz-radio-button [nzValue]="item.lookupKey">{{item.lookupValue | technicalTranslate}}</label>
          </ng-container>
          <!-- <label nz-radio-button [nzValue]="Passed">Accepted</label>
          <label nz-radio-button [nzValue]="Failed">Referred</label> -->
        </nz-radio-group>
        <div class="f-s-1-3r p-r-5">
          <span>{{rulesData.length}} Rules </span> &bull;
          <ng-container *ngFor="let item of decisionCountArray; let last = last;">
            <span [ngClass]="applyClass(item.name)">{{item.count}} {{item.name | technicalTranslate}}</span><span *ngIf="!last">&bull;</span>
          </ng-container>
          
          <!-- <span class="col-red">{{negativeCount}} Referred</span> -->
        </div>
        <!-- <div class="f-s-1-3r p-r-5">
          <span class="clickable" (click)="filterRules('ALL',insuredObj.id)">{{rulesData.length}} Rules </span> &bull;
          <span class="col-green clickable" (click)="filterRules('Passed',insuredObj.id)">{{rulesPassedCount}}
            Accepted</span>&bull;
          <span class="col-red clickable" (click)="filterRules('Failed',insuredObj.id)">{{rulesFailedCount}} Referred
          </span>
        </div> -->
      </div>

      <h3 class="heading d-b m-t-b-20"><i nz-icon nzType="profile"></i> Showing {{rulesRadio.toString().toLowerCase()}}
        rules
        ({{rulesDataFiltered.length}})</h3>

      <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="rulesLoading">
        <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false">
          <thead class="table-header">
            <tr>
              <th nzCustomFilter class="">Rule Name
                <nz-filter-trigger [nzDropdownMenu]="menu">
                  <i nz-icon nzType="search"></i>
                </nz-filter-trigger>
                <!-- <i nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown" nzType="search"
                  [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible" nzTrigger="click"
                  nzPlacement="bottomRight" [nzClickHide]="false" nzTableFilter></i> -->
              </th>
              <th class="" nzShowFilter [nzFilters]="listOfCategories" (nzFilterChange)="filterRulesOnCategory($event)">
                Rule Category</th>
              <th class="">Decision</th>
              <!-- <th class="" style="width: 170px">Decision Value</th> -->
              <th class="">Recommendation</th>
            </tr>
          </thead>
          <tbody class="">
            <!-- <ng-container *ngFor="let ruleCategory of ruleCategories"> -->
            <!-- <tr style="background-color: #f0f8ff">
                <td colspan="21">
                  <h5 *ngIf="ruleCategory" class="m-0 p-0">Category:
                    {{ruleCategory | technicalTranslate}}({{getRulesCategorized(ruleCategory)? getRulesCategorized(ruleCategory).length : '0'}})
                  </h5>
                  <h5 *ngIf="!ruleCategory" class="m-0 p-0">Uncategorized
                    ({{getRulesCategorized(ruleCategory)? getRulesCategorized(ruleCategory).length : '0'}})</h5>
                </td>
              </tr> -->
            <tr class="table-row" *ngFor="let rule of rulesDataFiltered">
              <td class="">{{((rule.name || rule.ruleName) | technicalTranslate) || "-"}}</td>
              <td class="">{{(rule.category | technicalTranslate) || "-"}}</td>
              <td [ngClass]="applyClass(rule.decision)">{{(rule.decision | technicalTranslate) || "-"}}</td>
              <!-- <td
                [class.col-green]="rule.decision=='Accepted' || rule.decision=='ACCEPTED' || rule.decision=='STANDARD'"
                [class.col-red]="rule.decision=='Refer' || rule.decision=='REFER'" class="">
                {{(rule.decision | technicalTranslate) || "-"}}</td> -->
              <!-- <td class="">{{rule.decisionValue || "-"}}</td> -->
              <td class="">{{(rule.recco || rule.recommendation) || "-"}}</td>
            </tr>
            <!-- </ng-container> -->
          </tbody>
        </nz-table>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <div class="search-box">
            <input type="text" nz-input placeholder="Search Rule" [(ngModel)]="searchValue" />
            <button nz-button nzSize="small" nzType="primary" (click)="searchRules(searchValue)" class="search-button">
              Search
            </button>
            <button nz-button nzSize="small" (click)="reset()">Reset</button>
          </div>
        </nz-dropdown-menu>
      </nz-skeleton>
    </div>

    <nz-alert class="m-b-20" *ngIf="showOverAllDecisionAlert"
      nzType="info"
      nzMessage="Overall Decision:"
      [nzDescription]="overAllDecisionContent"
      nzShowIcon
    ></nz-alert>

    <app-data-list [listOfData]="rulesDataFiltered" [title]="'Rules'" [listFor]="'UNDERWRITING_RULES'"></app-data-list>

  </nz-tab>
  
  <nz-tab [nzTitle]="titleTmplInsuredDecision" *ngFor="let insuredObj of insuredList;let i = index"
    (nzClick)="filterRules('ALL',insuredObj.id)">
    <ng-template #titleTmplInsuredDecision>
      <strong class="d-b">Insured {{i + 1}}: {{insuredObj | MMSClientData: 'fullName'}}</strong>
    </ng-template>
    <div *ngIf="false" class="rules-section" style="overflow-x: scroll">
      <div class="flex flex-horiz-space-bw m-t-b-10">
        <nz-radio-group [(ngModel)]="rulesRadio" [nzButtonStyle]="'solid'"
          (ngModelChange)="filterRules(rulesRadio,insuredObj.id)">
          <ng-container *ngFor="let item of decisionCategoryLookup">
            <label nz-radio-button [nzValue]="item.lookupKey">{{item.lookupValue | technicalTranslate}}</label>
          </ng-container>
          <!-- <label nz-radio-button [nzValue]="Passed">Accepted</label>
          <label nz-radio-button [nzValue]="Failed">Referred</label> -->
        </nz-radio-group>
        <!-- <div class="f-s-1-3r p-r-5">
          <span>{{rulesData.length}} Rules </span> &bull;
          <ng-container *ngFor="let item of decisionCountArray; let last = last;">
            <span [ngClass]="applyClass(item.name)">{{item.count}} {{item.name | technicalTranslate}}</span><span *ngIf="!last">&bull;</span>
          </ng-container>
          
        </div> -->
        <!-- <div class="f-s-1-3r p-r-5">
          <span class="clickable" (click)="filterRules('ALL',insuredObj.id)">{{rulesData.length}} Rules </span> &bull;
          <span class="col-green clickable" (click)="filterRules('Passed',insuredObj.id)">{{rulesPassedCount}}
            Accepted</span>&bull;
          <span class="col-red clickable" (click)="filterRules('Failed',insuredObj.id)">{{rulesFailedCount}} Referred
          </span>
        </div> -->
      </div>

      <h3 class="heading d-b m-t-b-20"><i nz-icon nzType="profile"></i> Showing {{rulesRadio.toString().toLowerCase()}}
        rules
        ({{rulesDataFiltered.length}})</h3>

      <nz-skeleton [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" [nzLoading]="rulesLoading">
        <nz-table [nzData]="[1,2,3]" [nzShowPagination]="false">
          <thead class="table-header">
            <tr>
              <th nzCustomFilter class="">Rule Name
                <nz-filter-trigger [nzDropdownMenu]="menu">
                  <i nz-icon nzType="search"></i>
                </nz-filter-trigger>
                <!-- <i nz-th-extra class="ant-table-filter-icon" nz-icon nz-dropdown #dropdown="nzDropdown" nzType="search"
                  [nzDropdownMenu]="menu" [class.ant-table-filter-open]="dropdown.nzVisible" nzTrigger="click"
                  nzPlacement="bottomRight" [nzClickHide]="false" nzTableFilter></i> -->
              </th>
              <th class="" nzShowFilter [nzFilters]="listOfCategories" (nzFilterChange)="filterRulesOnCategory($event)">
                Rule Category</th>
              <th class="">Decision</th>
              <th class="" style="width: 170px">Decision Value</th>
              <th class="">Recommendation</th>
            </tr>
          </thead>
          <tbody class="">
            <!-- <ng-container *ngFor="let ruleCategory of ruleCategories"> -->
            <!-- <tr style="background-color: #f0f8ff">
                <td colspan="21">
                  <h5 *ngIf="ruleCategory" class="m-0 p-0">Category:
                    {{ruleCategory | technicalTranslate}}({{getRulesCategorized(ruleCategory)? getRulesCategorized(ruleCategory).length : '0'}})
                  </h5>
                  <h5 *ngIf="!ruleCategory" class="m-0 p-0">Uncategorized
                    ({{getRulesCategorized(ruleCategory)? getRulesCategorized(ruleCategory).length : '0'}})</h5>
                </td>
              </tr> -->
            <ng-container *ngFor="let rule of rulesDataFiltered">
            <tr class="table-row" *ngIf="insuredObj.id == rule.clientId">
              <td class="">{{((rule.name || rule.ruleName) | technicalTranslate) || "-"}}</td>
              <td class="">{{(rule.category | technicalTranslate) || "-"}}</td>
              <td [ngClass]="applyClass(rule.decision)">{{(rule.decision | technicalTranslate) || "-"}}</td>
              <!-- <td
                [class.col-green]="rule.decision=='Accepted' || rule.decision=='ACCEPTED' || rule.decision=='STANDARD'"
                [class.col-red]="rule.decision=='Refer' || rule.decision=='REFER'" class="">
                {{(rule.decision | technicalTranslate) || "-"}}</td> -->
              <td class="">{{(rule.decisionValue | technicalTranslate) || "-"}}</td>
              <td class="">{{(rule.recco || rule.recommendation) || "-"}}</td>
            </tr>
            </ng-container>
            <!-- </ng-container> -->
          </tbody>
        </nz-table>
        <nz-dropdown-menu #menu="nzDropdownMenu">
          <div class="search-box">
            <input type="text" nz-input placeholder="Search Rule" [(ngModel)]="searchValue" />
            <button nz-button nzSize="small" nzType="primary" (click)="searchRules(searchValue)" class="search-button">
              Search
            </button>
            <button nz-button nzSize="small" (click)="reset()">Reset</button>
          </div>
        </nz-dropdown-menu>
      </nz-skeleton>
    </div>

    <app-data-list [listOfData]="rulesDataFiltered" [title]="'Rules'" [listFor]="'UNDERWRITING_RULES'"></app-data-list>

  </nz-tab>

</nz-tabset>